import { IActionContext, IRequestContext } from '@msdyn365-commerce/core';
import { FullProduct } from '@msdyn365-commerce/commerce-entities';
import {
    getSelectedVariant,
    SelectedVariantInput,
    createInventoryAvailabilitySearchCriteria,
    AttributesForSelectedVariantInput,
    getAttributesForSelectedVariantAction
} from '@msdyn365-commerce-modules/retail-actions';
import { getEstimatedAvailabilityAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { ProductWarehouseInventoryInformation, SimpleProduct, AttributeValue } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

export async function _getProductInventory(
    product: FullProduct,
    ctx: IActionContext
): Promise<ProductWarehouseInventoryInformation | undefined> {
    const searchCriteria = createInventoryAvailabilitySearchCriteria(ctx, [product.ProductDetails.RecordId], true);
    const productAvailabilitiesResponse = await getEstimatedAvailabilityAsync({ callerContext: ctx }, searchCriteria);
    return productAvailabilitiesResponse;
}

export async function getProductDetails(
    products: number[],
    channelId: number,
    context: IActionContext
): Promise<IHSOProductDetails[]> {
    let i = 0;
    let productsInventory: IHSOProductDetails[] = [];
    for (i = 0; i < products.length; i++) {
        let element: IHSOProductDetails = { productDetails: null, AttributeValues: null };
        if (products[i] !== undefined) {
            const simpleProduct = await _getProductDetails(products[i], channelId, context, context.requestContext);
            if (simpleProduct) {
                element.productDetails = simpleProduct;
            }
            productsInventory.push(element);
        }
    }
    return productsInventory;
}

export async function _getProductDetails(
    product: number,
    channelId: number,
    actionContext: IActionContext,
    requestContext: IRequestContext
): Promise<SimpleProduct | null> {
    const selectedProductPromise = getSelectedVariant(
        new SelectedVariantInput(
            product,
            channelId,
            undefined,
            undefined,
            requestContext
        ),
        actionContext
    );

    const selectedProduct: SimpleProduct | null = await selectedProductPromise;
    const selectedProductVariantPromise = getAttributesForSelectedVariantAction(
        new AttributesForSelectedVariantInput(
            product,
            channelId,
            selectedProduct!,
            0
        ),
        actionContext
    )
    const selectedVariantDetails = await selectedProductVariantPromise;
    selectedVariantDetails;
    return Promise.resolve(selectedProduct);
}

export async function _getProductDetailsWithAttributes(
    product: number,
    channelId: number,
    actionContext: IActionContext,
    requestContext: IRequestContext
): Promise<IHSOProductDetails | null> {
    const selectedProductPromise = getSelectedVariant(
        new SelectedVariantInput(
            product,
            channelId,
            undefined,
            undefined,
            requestContext
        ),
        actionContext
    );

    const selectedProduct: SimpleProduct | null = await selectedProductPromise;
    const selectedVariantAttributesPromise = getAttributesForSelectedVariantAction(
        new AttributesForSelectedVariantInput(
            product,
            channelId,
            selectedProduct!,
            0
        ),
        actionContext
    )
    const selectedVariantAttributes = await selectedVariantAttributesPromise;
    const productDetailsWithAtttributes : IHSOProductDetails = {productDetails: selectedProduct, AttributeValues: selectedVariantAttributes}
    return Promise.resolve(productDetailsWithAtttributes);
}

export interface IHSOProductDetails {
    productDetails: SimpleProduct | null;
    AttributeValues: AttributeValue[] | null;
}